module.exports = __webpack_public_path__ + "img/down_5.6e7fef93.png";